import { render, staticRenderFns } from "./SCBonusFilters.vue?vue&type=template&id=4f243dd6"
import script from "./SCBonusFilters.vue?vue&type=script&lang=js"
export * from "./SCBonusFilters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports